import React from 'react';
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SidebarRoute,
  SideBtnWrap
} from './SidebarElements';

const Sidebar = ({ isOpen, toggle, isHeader }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        {isHeader ? (
          <></>
        ) :
          <SidebarMenu>
            <SidebarLink
              to='about'
              onClick={() => toggle()}
              smooth={true}
              duration={500}
              spy={true}
              exact='true'
              offset={-80}
            >
              About
            </SidebarLink>
            {/* <SidebarLink
            to='discussion'
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact='true'
            offset={-80}
          >
            Discussion
          </SidebarLink>
          <SidebarLink
            to='GetStarted'
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact='true'
            offset={-80}
          >
            Get Started
          </SidebarLink> */}
          </SidebarMenu>
        }
        <SideBtnWrap style={{ marginTop: '20px' }}>
          <SidebarRoute to='/account'>Account</SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
